require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/floors/sports-advice/sports-advice.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/floors/sports-advice/sports-advice.legacy.js
// module id = 712
// module chunks = 31